import theme from 'theme';

export const styles = {
    container: {
        height: '100%',
        maxHeight: 'calc(100vh - 250px)',
    },
    textFieldBox: {
        position: 'relative',
        height: 'auto',
        maxHeight: 'calc(100vh - 350px)',
        display: 'flex',
        flexDirection: 'column',
    },
    textFieldInput: {
        flex: 1,
        '& .MuiInputBase-inputMultiline': {
            maxHeight: '420px',
            overflowY: 'auto !important',
        },
    },
    previewContainer: {
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: 4,
        height: '600px',
        display: 'flex',
        flexDirection: 'column',
    },
    previewHeader: {
        minHeight: 80,
        backgroundColor: 'action.hover',
        borderRadius: '16px 16px 0 0',
    },
    messageArea: {
        flexGrow: 1,
        backgroundColor: `${theme.palette.common.white}`,
        px: 2,
        py: 1,
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 400px)',
    },
    messageBubble: {
        backgroundColor: '#E5E5EA',
        borderRadius: '20px',
        p: 2,
        maxWidth: '75%',
        alignSelf: 'flex-start',
        position: 'relative',
        marginBottom: '10px',
        '&::before': {
            // This creates the actual tail shape
            content: '""',
            position: 'absolute',
            zIndex: 0,
            bottom: 0,
            left: '-7px',
            height: '20px',
            width: '20px',
            backgroundColor: '#E5E5EA',
            borderBottomRightRadius: '15px',
        },
        '&::after': {
            // This masks part of the tail to create the curved effect
            content: '""',
            position: 'absolute',
            zIndex: 1,
            bottom: 0,
            left: '-10px',
            width: '10px',
            height: '20px',
            backgroundColor: `${theme.palette.common.white}`,
            borderBottomRightRadius: '10px',
        },
    },
    messageText: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        width: '100%',
    },
    inputArea: {
        p: 2,
        backgroundColor: `${theme.palette.common.white}`,
        alignItems: 'center',
        borderRadius: 4,
    },
    inputField: {
        flex: 1,
        border: `0.5px solid #3C3C435C`,
        borderRadius: '30px',
        px: 2,
        minHeight: '36px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
};
